import { render } from "./Minister.vue?vue&type=template&id=289558db&scoped=true&ts=true"
import script from "./Minister.ts?vue&type=script&lang=ts"
export * from "./Minister.ts?vue&type=script&lang=ts"

import "./Minister.scss?vue&type=style&index=0&id=289558db&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289558db"]])

export default __exports__